import { InitialValuesType } from "src/core/types/questions-school-leader-type";

export const initialValues: InitialValuesType = {
  InfrastructureAndFacilities: [],
  AcademicOffers: [],
  AvailableAcademicSystems: [],
  ClassesOffered: [],
  gender: [],
  EducationalStaff: [],
  SupportStudents: [],
  HealthAndSafety: [],
  ExtraCurricularActivities: [],
  CommunityInvolvement: [],
  TechnologyAndResources: [],
  Transport: [],
  SpecialPrograms: [],
  ParentParticipation: [],
  StudentConductAndDiscipline: [],
  CareerPreparation: [],
  CommunicationWithParents: [],
  other: [],
};
